@if(partyForm()){
<form [formGroup]="partyForm()" [class.party-form-mobile]="appSettings.isMobile()">
    <div class="row g-3 mb-3">
        <div class="col-6 col-md-2">
            <div class="form-group party-field">
                <label class="form-label">Rut</label>
                @if(mode() == formMode.CREATE||mode() == formMode.EDIT){
                <input type="text" class="form-control" formControlName="rut">
                }@else{
                <div class="party-field-value">{{ partyForm().get('rut')?.value ? (partyForm().get('rut')?.value | rutFormat) : '—' }}</div>
                }
            </div>
        </div>
        <div class="col-6 col-md-4 order-md-3">
            <div class="form-group party-field">
                <label class="form-label">Tipo de Socio</label>
                @if(mode() == formMode.CREATE||mode() == formMode.EDIT){
                <app-sheet-select [items]="partyTypes" [clearable]="false" [searchable]="false"
                    bindLabel="name" bindValue="slug" title="Tipo de Socio"
                    placeholder="Seleccione un tipo de Socio"
                    formControlName="partyTypeSlug"></app-sheet-select>
                }@else{
                <div class="party-field-value">{{ displayValue(findPartyType(partyForm().get('partyTypeSlug')?.value)) }}</div>
                }
            </div>
        </div>
        <div class="col-12 col-md-6 order-md-2">
            <div class="form-group party-field">
                <label class="form-label">Nombre o razón social</label>
                @if(mode() == formMode.CREATE||mode() == formMode.EDIT){
                <input type="text" class="form-control" formControlName="names">
                }@else{
                <div class="party-field-value">{{ displayValue(partyForm().get('names')?.value) }}</div>
                }
            </div>
        </div>
    </div>

    <div class="row g-3 mb-3">
        @if(partyForm().get('partyTypeSlug')?.value == 'NATURAL'){
        <div class="col-6 col-md-2 order-1">
            <div class="form-group party-field">
                <label class="form-label">Fecha de nacimiento</label>
                @if(mode() == formMode.CREATE||mode() == formMode.EDIT){
                <input type="date" class="form-control" formControlName="birthday">
                }@else{
                <div class="party-field-value">{{ partyForm().get('birthday')?.value ? (partyForm().get('birthday')?.value | date: 'dd/MM/yyyy') : '—' }}</div>
                }
            </div>
        </div>
        }
        <div class="col-6 col-md-4 order-2 order-md-3">
            <div class="form-group party-field">
                <label class="form-label">Teléfono</label>
                @if(mode() == formMode.CREATE||mode() == formMode.EDIT){
                <input type="text" class="form-control" formControlName="mobileNumber">
                }@else{
                <div class="party-field-value">{{ partyForm().get('mobileNumber')?.value ? (partyForm().get('mobileNumber')?.value | phoneFormat) : '—' }}</div>
                }
            </div>
        </div>
        <div class="col-12 col-md-6 order-3 order-md-2">
            <div class="form-group party-field">
                <label class="form-label">Correo</label>
                @if(mode() == formMode.CREATE||mode() == formMode.EDIT){
                <input type="email" class="form-control" formControlName="mail">
                }@else{
                <div class="party-field-value party-field-value-break">{{ displayValue(partyForm().get('mail')?.value) }}</div>
                }
            </div>
        </div>
    </div>

    <div class="row g-3 mb-3">
        <div class="col-12 col-md-6">
            <div class="form-group party-field">
                <label class="form-label">Grupo</label>
                @if(mode() == formMode.CREATE||mode() == formMode.EDIT){
                <app-sheet-select [items]="groups" [clearable]="true" [searchable]="true"
                    bindLabel="name" bindValue="slug" title="Grupo"
                    placeholder="Seleccione un Grupo"
                    formControlName="groupSlug"></app-sheet-select>
                }@else{
                <div class="party-field-value">{{ displayValue(findGroup(partyForm().get('groupSlug')?.value) || 'Sin Grupo') }}</div>
                }
            </div>
        </div>
        <div class="col-12 col-md-6">
            <div class="form-group party-field">
                <label class="form-label">Entidad</label>
                @if(mode() == formMode.CREATE||mode() == formMode.EDIT){
                <app-sheet-select [items]="entities" [clearable]="false" [searchable]="entities.length > 5"
                    bindLabel="name" bindValue="code" title="Entidad"
                    placeholder="Seleccione una Entidad"
                    formControlName="entityCode" [readonly]="mode() == formMode.EDIT"></app-sheet-select>
                }@else{
                <div class="party-field-value">{{ displayValue(partyForm().get('entityCode')?.value) }} - {{ displayValue(findEntity(partyForm().get('entityCode')?.value) || 'Sin Entidad') }}</div>
                }
            </div>
        </div>
    </div>
</form>
<div class="party-form-actions" [class.party-form-actions-mobile]="appSettings.isMobile()">
    <ng-content><!-- contenido adicional por el padre --> </ng-content>
</div>
}
